import "../Assets/scss/BulkEnroll.scss";
import { Button, Card, CardContent, Checkbox, FormLabel } from "@mui/material";
import { developAxios } from "../axios.config";
import { Store } from "react-notifications-component";
import { useMutation, useQuery } from "react-query";
import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import axios from "axios";

interface ISelectedTemplateState {
	_id: string;
	name: string;
}

export default function SignupAndEnrolling() {
	const [file, setFile] = useState<File | null>(null);
	const [course, setCourse] = useState<{
		value: string;
		label: string;
	} | null>(null);
	const [emailTemplate, setEmailTemplate] = useState<{
		value: string;
		label: string;
	} | null>(null);
	const [csvUrl, setCsvUrl] = useState<string | null>(null);

	const fileUploadRef = useRef<HTMLInputElement>(null);

	const { data: templates } = useQuery(
		["superadmin", "get-email-teplates"],
		() => {
			return developAxios(localStorage.getItem("token") || "")
				.get<{
					data: ISelectedTemplateState[];
				}>("/superadmin/course/email-templates")
				.then(({ data }) =>
					data.data.map((val) => ({
						value: val._id,
						label: val.name,
					}))
				);
		},
		{
			initialData: [],
		}
	);

	const { data: courses } = useQuery(["getallcourse"], () =>
		developAxios(localStorage.getItem("token") || "")
			.get<{
				courses: Array<{
					_id: string;
					name: string;
				}>;
			}>("/getallcourse")
			.then(({ data }) => {
				return data.courses.map((val) => ({
					value: val._id,
					label: val.name,
				}));
			})
	);
	const { mutate: uploadFile } = useMutation(
		async () => {
			if (!fileUploadRef.current) return;
			if (!course) {
				return Promise.reject("Select a course to upload file");
			}

			const {
				data: {
					data: { presignedUrl, url },
				},
			} = await developAxios(localStorage.getItem("token") || "").get<{
				data: { presignedUrl: string; url: string };
			}>(
				"/superadmin/course/bulk-enroll/get-presigned-url/" +
					course.value
			);

			setCsvUrl(url);
			console.log(file);
			console.log(typeof file);

			await axios.put(presignedUrl, file);
		},
		{
			onError: (error: any) => {
				setFile(null);
				if (error.name === "AxiosError") {
					const error_message = error.response.data.message;
					notifyPopup(error_message, "danger");
					return;
				}
				notifyPopup(error, "danger");
			},
			onSuccess: () => {
				notifyPopup("File upload successful", "success");
			},
		}
	);

	const { mutate: enrollStudents } = useMutation(
		async () => {
			if (!course) {
				return Promise.reject("Select a course to upload file");
			}
			if (!csvUrl) {
				return Promise.reject(
					"Upload a file, before enrolling the users."
				);
			}
			if (!emailTemplate) {
				return Promise.reject("Select an email template to proceed");
			}
			return developAxios(localStorage.getItem("token") || "").post(
				"/superadmin/course/bulk-enroll-students/" + course.value,
				{
					emailTemplateId: emailTemplate.value,
					csvLink: csvUrl,
				}
			);
		},
		{
			onError: (error: any) => {
				setCsvUrl(null);
				setCourse(null);
				setEmailTemplate(null);
				setFile(null);
				if (error.name === "AxiosError") {
					const error_message = error.response.data.message;
					notifyPopup(error_message, "danger");
					return;
				}
				notifyPopup(error, "danger");
			},
			onSuccess: () => {
				notifyPopup("Users will be enrolled shortly", "success");
			},
		}
	);

	// useEffect(() => {
	//   if (!file) return
	//   uploadFile()
	// }, [file, uploadFile])

	useEffect(() => {
		if (!file) return;

		uploadFile();
	}, [file, uploadFile]);

	function notifyPopup(backend_message: string, type: "success" | "danger") {
		Store.addNotification({
			title: type === "danger" ? "Error Occured" : "Success",
			message: backend_message,
			type: type,
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	}

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files) {
			setFile(e.target.files[0]);
		}
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		enrollStudents();
	};

	return (
		<Card className="w-full max-w-md mx-auto" sx={{ overflow: "visible" }}>
			<CardContent>
				<form onSubmit={handleSubmit} className="space-y-4">
					<div className="space-y-2">
						<FormLabel htmlFor="csv-upload">Upload CSV</FormLabel>
						<div>
							<span className="underline">
								Column 1=Name, Column 2=Email
							</span>
						</div>
						<div className="flex items-center justify-center w-full">
							<label
								htmlFor="csv-upload"
								className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
							>
								<div className="flex flex-col items-center justify-center pt-5 pb-6">
									<svg
										className="w-8 h-8 mb-4 text-gray-500"
										aria-hidden="true"
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 20 16"
									>
										<path
											stroke="currentColor"
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth="2"
											d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
										/>
									</svg>
									<p className="mb-2 text-sm text-gray-500">
										<span className="font-semibold">
											Click to upload
										</span>{" "}
										or drag and drop
									</p>
									<p className="text-xs text-gray-500">
										CSV file only
									</p>
								</div>
								<input
									id="csv-upload"
									type="file"
									accept=".csv"
									className="hidden"
									onChange={handleFileChange}
									ref={fileUploadRef}
								/>
							</label>
						</div>
						{file && (
							<p className="text-sm text-gray-500">
								Selected file: {file.name}
							</p>
						)}
					</div>

					<div className="space-y-2">
						<FormLabel htmlFor="course-select">
							Select Course
						</FormLabel>
						<Select
							value={course}
							onChange={(e: any) => setCourse(e)}
							options={courses as any}
							closeMenuOnSelect={true}
						/>
					</div>

					<div className="space-y-2">
						<FormLabel htmlFor="course-select">
							Select Email Template
						</FormLabel>
						<Select
							value={emailTemplate}
							onChange={(e: any) => setEmailTemplate(e)}
							options={templates as any}
							closeMenuOnSelect={true}
						/>
					</div>

					<Button
						type="submit"
						className="w-full"
						variant="contained"
					>
						Submit
					</Button>
				</form>
			</CardContent>
		</Card>
	);
}
